import { useMemo } from 'react';

import { Box, Link, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { Link as RouterLink } from 'react-router-dom';
import { useAuthContext } from 'src/context/AuthContextProvider';
import OperationWalletTable from 'src/pages/Operation/OperationWalletTable';
import { convertNumber, convertValue } from 'src/utils/number';

import { WalletFIDCRow } from '../types';

interface WalletFIDCProps {
  data: WalletFIDCRow[];
  isLoading: boolean;
}

export default function WalletFIDC({
  data,
  isLoading,
}: WalletFIDCProps): JSX.Element | null {
  const { auth } = useAuthContext();

  const columns: MRT_ColumnDef<any>[] = useMemo(
    () => [
      {
        accessorKey: 'name',
        accessorFn: (row) => row?.operation?.name,
        header: 'FIDC',
        Cell: ({ cell }: { cell: any }) =>
          cell.getValue() ? cell.getValue() : '-',
      },
      {
        accessorKey: 'quantidade',
        header: 'Quantidade de cotas',
        accessorFn: (row) => parseInt(row.quantidade),
        Cell: ({ cell }: { cell: any }) =>
          cell.getValue() ? convertNumber(cell.getValue()) : '-',
      },
      {
        accessorKey: 'valor',
        header: 'Valor',
        accessorFn: (row) => parseFloat(row.valor.replace(',', '.')),
        Cell: ({ cell }: { cell: any }) =>
          cell.getValue() ? convertValue(cell.getValue()) : '-',
      },
      {
        accessorKey: 'operation',
        header: 'Ação',
        Cell: ({ cell }: { cell: any }) =>
          cell.getValue() ? (
            <Link
              component={RouterLink}
              to={`/operacao/${cell.getValue().market}/${
                cell.getValue().slug
              }/${cell.getValue().operationId}`}>
              Ver operação
            </Link>
          ) : (
            'Operação não encontrada'
          ),
      },
    ],
    [],
  );

  const hasPermission =
    auth?.user?.subscription?.plan?.permissions?.operacoes_fii_ativo_carteira;

  if (!data.length) return null;

  return (
    <Box>
      <Typography
        sx={{
          fontSize: '20px',
          fontWeight: 600,
          lineHeight: '22px',
          marginLeft: 1,
        }}>
        FIDC
      </Typography>
      <OperationWalletTable
        hasPermission={!!hasPermission}
        data={data}
        columns={columns}
        isLoading={isLoading}
      />
    </Box>
  );
}
